import * as React from 'react';

import classnames from 'classnames';

import type {SalesAutomationItemType} from '../../../../sales-automation/types';

import {SalesAutomationCard} from './sales-automation-card';

import styles from './sales-automation-new-card.module.css';

type Props = {
    parentId: string;
    isHidden: boolean;
    type: SalesAutomationItemType;
};

export class SalesAutomationNewCard extends React.PureComponent<Props> {
    render() {
        const typeClass = classnames({
            [styles['user-assignment']]: this.props.type === 'userAssignments',
            [styles.goal]: this.props.type === 'goals',

            [styles.task]:
                this.props.type === 'stepTemplates' ||
                this.props.type === 'closedLeadTaskTemplates',

            [styles.email]:
                this.props.type === 'emails' ||
                this.props.type === 'constantContactEmails' ||
                this.props.type === 'nutshellEmailMarketing',

            [styles.slack]: this.props.type === 'slack',
            [styles['account-assignment']]: this.props.type === 'closedLeadAccountTypeAutomations',
        });

        return (
            <div className={typeClass}>
                <SalesAutomationCard
                    parentId={this.props.parentId}
                    type={this.props.type}
                    isHidden={this.props.isHidden}
                    clearFocusAfterClick={true}
                >
                    <div className={styles.label}>+</div>
                </SalesAutomationCard>
            </div>
        );
    }
}
